import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useSingleResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useSingleResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export const ActivitiesModelResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.ACTIVITIES_MODEL).default(ResourceType.ACTIVITIES_MODEL),
    BPMNModel: z.string(),
});
export const ActivitiesModelMutationResourceSchema = getMutationSchema(ActivitiesModelResourceSchema);

export type ActivitiesModelResource = z.infer<typeof ActivitiesModelResourceSchema>;

export const defaultActivitiesModelResource: ActivitiesModelResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.ACTIVITIES_MODEL,
    BPMNModel: '',
};

export function useActivitiesModelActions() {
    return {
        ...useSingleResourceSingleParentedResourceAdapterActions(
            'project/activities-model',
            ResourceType.ACTIVITIES_MODEL,
            ActivitiesModelResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/activities-model',
            ResourceType.ACTIVITIES_MODEL,
            ActivitiesModelResourceSchema
        ),
    };
}
